import Collapse from 'bootstrap/js/dist/collapse';

class StappenAfbeelding {
	constructor(config) {
		this.config = Object.assign({
			scope: '.stappen_afbeelding',
			container: '.steps-container',
			measuring: 'measuring',
			anchor: 0.5
		}, config);

		this.scope = document.querySelectorAll(this.config.scope);
		if (this.scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.sections = [...this.scope].map((section) => {
			const container = section.querySelector(this.config.container);

			if (!container) {
				return null;
			}

			const steps = [...container.querySelectorAll('.step')]
				.map((step) => ({
					toggle: step.querySelector('[data-bs-toggle="collapse"]'),
					collapse: step.querySelector('.collapse')
				}))
				.filter((step) => step.toggle && step.collapse);

			return steps.length > 0 ? { container, steps } : null;
		}).filter(Boolean);

		if (this.sections.length === 0) {
			return;
		}

		this.width = window.innerWidth;

		this.#reserve();

		window.addEventListener('scroll', () => this.#request(), { passive: true });
		window.addEventListener('resize', () => this.#resize());

		// Webfonts change the text height, so re-reserve once they are in.
		if (document.fonts) {
			document.fonts.ready.then(() => this.#reserve());
		}

		this.#update();
	}

	#resize() {
		// Mobile browsers fire resize while scrolling (address bar), ignore those.
		if (window.innerWidth === this.width) {
			this.#request();
			return;
		}

		this.width = window.innerWidth;
		this.#request(true);
	}

	#request(reserve = false) {
		if (reserve) {
			this.reserve = true;
		}

		if (this.ticking) {
			return;
		}

		this.ticking = true;

		requestAnimationFrame(() => {
			this.ticking = false;

			if (this.reserve) {
				this.reserve = false;
				this.#reserve();
			}

			this.#update();
		});
	}

	/**
	 * Locks the container to the height it would have with every step open,
	 * so opening a step during scroll can no longer shift the sticky column.
	 */
	#reserve() {
		this.sections.forEach(({ container }) => {
			container.style.minHeight = '';
			container.classList.add(this.config.measuring);

			const height = container.getBoundingClientRect().height;

			container.classList.remove(this.config.measuring);
			container.style.minHeight = `${Math.ceil(height)}px`;
		});
	}

	#update() {
		const line = window.innerHeight * this.config.anchor;

		this.sections.forEach(({ steps }) => {
			let match = steps[0];

			// Steps are in DOM order, so the last one above the line is the closest to it.
			steps.forEach((step) => {
				if (step.toggle.getBoundingClientRect().top <= line) {
					match = step;
				}
			});

			if (match.collapse.classList.contains('show')) {
				return;
			}

			Collapse.getOrCreateInstance(match.collapse, { toggle: false }).show();
		});
	}
}

export default new StappenAfbeelding;
